<!-- @format -->

<style lang="less">
@import './login.less';
</style>

<template>
  <div class="login" v-if="isShow">
    <!-- 渠道端(有背景图) -->
    <div class="logincon" v-if="+domaindata.use_bg_image === 1" :style="{ background: 'url(' + coverImgUrl + ') center center no-repeat fixed' }">
      <div style="text-align:right">
        <Button type="default" class="qudao-btn" ghost style="margin:10px 10px 0 0" @click="openmodMan">主办方管理后台</Button>
      </div>
      <div style="position: fixed; top: 6%; left: 58%">
        <div class="login-con" style="border: 0; width: 510px">
          <div v-if="this.domain.includes(this.locationOrigin)">
            <p class="psty2">{{ this.title1 }}</p>
            <div class="psty2" style="margin-bottom: 10px; display: flex;">
              <p>{{ this.title2 }}</p>
            </div>
          </div>

          <div v-else>
            <p class="psty">{{ this.title1 }}</p>
            <div class="psty" style="margin-bottom: 10px; display: flex">
              <p class="subtitle">{{ this.title2 }}</p>
            </div>
          </div>
          <div class="form-con" style="display: flex;">
            <!-- 渠道端登录注组件 -->
            <LoginFormelse />
          </div>
        </div>
      </div>
    </div>
    <!-- 渠道端如果没有上传背景图，则使用企业端布局 -->
    <!-- 企业端 -->
    <section v-else class="qiye-login-bg">
      <div class="form-login-wrap">
        <div class="form-login"><login-form></login-form></div>
      </div>
      <img class="bg" src="@/assets/image/login_bg.png" alt="" />
      <div class="top-wrap" v-if="isChannel">
        <h4>校园招聘火热进行中</h4>
        <Button @click="openmodMan" type="primary" class="plain btn">主办方管理后台</Button>
      </div>
      <img v-else class="logo" src="@/assets/image/logo_biyeshen.png" alt="" />
    </section>
    <!--  企业渠道登录 -->
    <Modal class-name="schoolBox" v-model="schoolBox" width="522">
      <div>
        <div class="modeltop">管理后台登录</div>
        <div class="schoolbox">
          <Form ref="loginForm" class="login-form" :model="form" :rules="rules" @keydown.enter.native="loginevent" style="width:100%">
            <FormItem prop="username" class="sms-wrapper" style="font-size: 20;">
              <Input v-model="form.username" placeholder="请输入用户名" />
            </FormItem>
            <FormItem prop="pwd" class="sms-wrapper">
              <Input v-model="form.pwd" type="password" placeholder="请输入密码" />
            </FormItem>
            <div class="forget-line">
              <span @click="handleForget" style="cursor: pointer">忘记密码？</span>
            </div>
            <Button size="large" type="primary" @click="loginevent" style="height:42px;margin-top: 15px; width: 100%; margin-bottom: 40px">登录</Button>
            <!-- </a> -->
          </Form>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
// import config from '../../config'
import LoginForm from '@/components/login-form/login-form.vue'
import LoginFormelse from '@/components/login-form/elselogin-form.vue'
import picture from '@/assets/image/login.png'
import background from '@/assets/image/bg.png'
import Footer from '@/components/UI/footer.vue'
// import { getcomset } from '@/api/user.js'
import { channelLogin,getcomset, getsiteInfo } from '@/api/indexPage.js'
import { setMeta } from '@/utils/utils'
import Cookies from 'js-cookie'

export default {
  components: {
    LoginForm,
    Footer,
    LoginFormelse
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    const validateUser = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入用户名'))
      } else {
        callback()
      }
    }
    return {
      browserType: '',
      isChannel: false,
      isShow: false,
      // headerText: config.headerText,
      background,
      picture,
      locationOrigin: '',
      coverImgUrl: '',

      domaindata: {},
      domain: ['https://huangpu.applyoffer.com'],
      title1: '',
      title2: '',
      schoolBox: false,

      form: {
        username: '',
        pwd: ''
      },

      rules: {
        pwd: [{ validator: validatePass, trigger: 'blur' }],
        username: [{ validator: validateUser, trigger: 'blur' }]
      },
      herfurl: `${window.location.origin}/op/#/schoolBroad/index`,
      hasChannel: false

      // isdomain:true,
      // isApplyoffer: true
    }
  },

  created() {
    this.browserTypeis()
    //用户退出的时候用来刷新,重置vuex,清除登录状态
    if (this.$route.params.flagreload) {
      location.reload()
    }

    //根据域名判断是渠道端还是普通企业端
    this.locationOrigin = window.location.origin
    this.getcomset(this.locationOrigin)
    this.getsiteInfo()
  },
  methods: {
    async getsiteInfo () {
      let data = {}
        // data.domain = ''
        if(process.env.NODE_ENV == "development") {
          console.log('development')
          data.domain = window.location.origin.split('//')[1]
          //开发环境
        } else if (process.env.NODE_ENV == "production") {
          //生产环境
          console.log('production')
          data.domain = ''


        }else{
          //本地环境
          console.log('本地')
        }
        await getsiteInfo(data).then((res) => {
          const channelData = res.channel
          const metaMap = {
            title: `${channelData.channel}校园招聘平台用人单位登录`,
            keyWord: `${channelData.channel},${channelData.short_name},校招平台,校园招聘会,校招`,
            desc: `${channelData.channel}校园招聘平台，用人单位招聘入口。`
          }
          if(res.type == 3) {
            // 渠道
            if(Cookies.get("login_type") == 'company') {
              if(Cookies.get('com_key_user')) window.location.href = `${window.location.origin}/company/#/`
            }else if(Cookies.get("login_type") == 'channel') {
              if(Cookies.get('channel_userid')) window.location.href = `${window.location.origin}/op/#/schoolBroad/index`
            }
          }
          setMeta(...Object.values(metaMap))
        })
    },
     browserTypeis() {
      let userAgentstr = navigator.userAgent.toLocaleLowerCase()
      if (/safari/.test(userAgentstr) && !/chrome/.test(userAgentstr)) {
        this.browserType = 'Safari'
      } else if (userAgentstr.match(/tencenttraveler/) != null || userAgentstr.match(/qqbrowse/) != null) {
        this.browserType = 'QQ'
      } else if (userAgentstr.match(/msie/) != null || userAgentstr.match(/trident/) != null) {
        this.browserType = 'IE'
      } else if (userAgentstr.indexOf('firefox') > -1) {
        // 判断是否Firefox浏览器
        this.browserType = 'Firefox'
      }
    },

    openmodMan() {
      if (!Cookies.get('channel_userid')) {
        this.schoolBox = true
      } else {
        var tempwindow = window.open('_blank') // 先打开页面
        tempwindow.location = this.herfurl // 后更改页面地址
      }
    },

    loginevent() {
      this.$refs['loginForm'].validate(valid => {
        if (valid) {
          channelLogin({
            username: this.form.username,
            password: this.form.pwd
          }).then(res => {
            console.log('login-res',res)
            if (res.apiStatus) {
              Cookies.set('channel_userid', res.user_id)
              Cookies.set("login_type", 'channel',{expires:14});
              Cookies.set('channel_channel_name', res.channel_name)
              this.schoolBox = false
              this.hasChannel = true
              window.location.href = `${window.location.origin}/op/#/schoolBroad/index`
            } else {
              if(res.data.code == '500002') {
                this.$Message.error('登录操作频繁，账号已被冻结，请24小时之后再试')
              }else {
                this.$Message.error(res.data.msg)
              }
            }
          })
        }
      })
    },

    handleForget() {
      const content = `        <div>
          <p>毕业申技术咨询</p>
          <p>微信：18618362798</p>
        <p>邮箱：info@applyoffer.com </p>
        <p>联系电话：021-66696957 </p>
        </div>`
      this.$Modal.info({
        title: '忘记密码, 请与我们联系',
        content: content
      })
    },

    getcomset(locationOrigin) {
      let data = {
        domain: locationOrigin.split('//')[1]
      }

      getcomset(data).then(res => {
        this.isShow = true
        console.log('getcomset-res',res)
        this.domaindata = res
        if (JSON.stringify(res) !== '{}') {
          if (res.use_bg_image) {
            this.coverImgUrl = res.bg_image
          }
          this.title1 = res.title
          this.title2 = res.subtitle
          Cookies.set('title1', res.title)
          Cookies.set('title2', res.subtitle)
          Cookies.set('platform', 'qudao')
          /* channel_type 1标注  2商业*/
          sessionStorage.setItem('channel_type', res.channel_type)
          this.isChannel = true
        } else {
          Cookies.set('title1', '毕业申')
          Cookies.set('title2', '校园招聘平台')
          Cookies.set('platform', 'qiye')
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.login {
  height: 100vh;
  overflow: hidden;
}
.logincon {
  height: 100vh;
  width: 100%;
  background: linear-gradient(134deg, #1c69ee 0%, #1a51d2 100%);
  background-attachment: fixed;
  overflow: hidden;
  position: relative;
  .qudao-btn {
    font-size: 14px;
    color: #333333;
    border-color: #EEEEEE;
    border-radius: 4px;
    background-color: #FFFFFF;
    position: relative;
    z-index: 99;
    &:hover {
      color: #366FF9;
      cursor: pointer;
    }
  }
}

.loginbox {
  width: 1205px;
  margin: 0 auto;
}

.psty {
  font-size: 20px;
  font-weight: bold;
  color: #ffffff;
  line-height: 30px;
  .subtitle {
    font-size: 18px;
    font-weight: 400;
    color: #ffffff;
  }
}

.psty2 {
  font-size: 20px;
  font-weight: 500;
  color: #303938;
  line-height: 30px;
}

.conbottext {
  height: 100px;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.botbox {
  font-size: 12px;
  color: #fff;
  display: flex;
}

.conbotbox {
  height: 100%;
  width: 100%;
  padding: 20px 40px 0 40px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.schoolbox {
  width: 320px;
  height: 100%;
  margin: 30px auto;
  .ivu-modal-body{
    padding: 0;
  }
}

.modeltop {
  height: 56px;
  width: 100%;
  border-radius: 8px 8px 0px 0px;
  background: #f4f7fe;
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  text-align: center;
  line-height: 56px;
}

.forget-line {
  text-align: right;
}
.qiye-login-bg {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  img.bg {
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
  }
  img.logo {
    position: absolute;
    z-index: 9;
    width: 142px;
    height: 40px;
    top: 16px;
    left: 18%;
  }
  .top-wrap {
    position: absolute;
    z-index: 9;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1200px;
    height: 64px;
    border-bottom: 1px solid #e8eaec;
    h4 {
      font-size: 16px;
      font-weight: 400;
    }
    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 116px;
      height: 32px;
      font-size: 14px;
      background: #ffffff;
      color: #356FFA;
      border: 1px solid #356FFA;
    }
    .btn:hover{
      background: #497DFA;
      border: 1px solid #497DFA;
      color: #FFFFFF;
    }
  }
  .form-login-wrap {
    height: 102vh;
    .form-login {
      position: absolute;
      top: 55%;
      transform: translate(-50%, -50%);
      left: 50%;
      z-index: 9;
    }
  }
}
</style>
<style>
.schoolBox .ivu-modal-body {
  padding: 0 !important;
  min-height: 320px;
}

.schoolBox .ivu-modal-footer {
  padding: 0;
  border: 0;
}
.schoolbox .ivu-input {
  height: 42px;
  width: 100%;
  background: #f6f7f9;
  border: 0;
  font-size: 14px;
  border-radius: 4px !important;
}

.schoolbox .ivu-form-item {
  margin-bottom: 22px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue